<template>
  <div class="area-content">
    <div ref="area" class="mainArea" v-if="showNum == 3">
      <div class="patient-box">
        <div class="head-pic">
          <img src="../../assets/img/hslogo2.png" alt="" style="width:100%;height:100%;" />
        </div>
      </div>
      <div class="order-box" style="width: 100%; display: flex; justify-content: center; flex-wrap: wrap;">
        <el-form ref="ruleLoginForm" label-width="80px" :model="ruleLoginForm" :rules="loginRules" label-position="top" style="width: 70%;">
          <el-form-item label="登录账号：" prop="account">
            <el-input v-model.trim="ruleLoginForm.account" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="登录密码：" prop="password">
            <el-input :type="psType" v-model.trim="ruleLoginForm.password" placeholder="请输入密码">
              <i
                class="el-icon-view el-input__icon"
                slot="suffix"
                :style="{ color: psType == 'password' ? '' : '#2D99D7' }"
                @click="handleIconClick"
              >
              </i>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="comfirm-btn">
          <el-button type="primary" style="width: 70%;height: 40px;font-size: 16px;" @click.stop="submitLoginForm('ruleLoginForm')"
            >登录</el-button
          >
        </div>
        <!-- <div style="color:#606266;font-size: 14px;margin-top: 20px;">
          <p style="margin: 20px 0 10px 0;">温馨提示：</p>
          <p style="margin-bottom: 6px;">&nbsp;&nbsp;客服电话：400-894-5099</p>
          <p>&nbsp;&nbsp;查询周期为近一个月报告，若报告未出请您耐心等待。</p>
        </div> -->
      </div>
    </div>
    <div ref="area" class="mainArea" v-if="showNum == 1">
      <div class="patient-box">
        <div class="head-pic">
          <img src="../../assets/img/hslogo2.png" alt="" style="width:100%;height:100%;" />
        </div>
      </div>
      <div class="order-box" style="width: 100%; display: flex; justify-content: center; flex-wrap: wrap;">
        <el-form ref="ruleForm" label-width="80px" :model="ruleForm" :rules="rules" label-position="top" style="width: 70%;">
          <el-form-item label="患者姓名：" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入患者姓名"></el-input>
          </el-form-item>
        </el-form>
        <div class="comfirm-btn">
          <el-button type="primary" style="width: 70%;height: 40px;font-size: 16px;" @click.stop="submitForm('ruleForm')">查 询</el-button>
        </div>
        <div style="color:#606266;font-size: 14px;margin-top: 20px;">
          <p style="margin: 20px 0 10px 0;">温馨提示：</p>
          <p style="margin-bottom: 6px;">&nbsp;&nbsp;客服电话：400-894-5099</p>
          <p>&nbsp;&nbsp;查询周期为近一个月报告，若报告未出请您耐心等待。</p>
        </div>
      </div>
    </div>
    <div class="mainArea" v-if="showNum == 2">
      <div class="orderListBox">
        <div class="orderListItem" v-for="(item, index) in reportList" :key="index" @click="exportPreview(item)" style="position: relative">
          <!-- <div class="orderListBoxLine"></div> -->
          <div class="leftBox">
            <div class="orderListItemLT2" style="background-color: #ff8662;">检测报告</div>
            <div class="leftBoxName">{{ item.patientName }}</div>
            <div class="leftBoxSxe">{{ item.patientSex }} / {{ item.patientAge }}</div>
          </div>
          <div class="centerBox">
            <div class="centerBoxTime">{{ item.createTime }}</div>
            <div class="centerBoxRegion">
              <p v-for="(j, i) in item.pslNameArr" :key="i">{{ j }};</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcList" /> -->
    </div>
    <div class="reabckBtn" v-if="showNum == 2" @click="rebackHome">
      <i class="el-icon-s-home" style="font-size: 16px;"></i>
      <p style="width: 100%;text-align: center;font-size: 12px;">返回</p>
    </div>

    <!-- <div class="bottom-tips" v-if="showNum == 1">
      <p>@版权所有：上海中健佳益健康管理有限公司</p>
    </div> -->
  </div>
</template>

<script>
// import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import request from '@/utils/request';
import wx from 'weixin-js-sdk';
export default {
  name: 'lhReport',
  components: {
    // ElImageViewer
  },
  data: function() {
    return {
      showNum: 6, //3登录 1查询 2报告
      psType: 'password',
      ruleForm: {
        name: ''
      },
      rules: {
        name: [{ required: true, message: '请输入查询姓名', trigger: 'blur' }]
      },
      ruleLoginForm: {
        account: '',
        password: ''
      },
      loginRules: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      showViewer: false,
      srcList: [],
      reportList: [],
      lhToken: ''
    };
  },
  beforeCreate() {
    document.title = '报告查询';
  },
  created() {
    // 账号
    let lhAccount = localStorage.getItem('lhAccount');
    if (lhAccount) this.tokenAgain(lhAccount);
    else this.showNum = 3;
  },
  methods: {
    tokenAgain(account) {
      this.ruleLoginForm = JSON.parse(account);
      //token校验
      if (localStorage.getItem('lhToken')) {
        this.lhToken = localStorage.getItem('lhToken');
        this.jugeToken(); //判断token是否过期
      } else {
        this.showNum = 3;
        this.lhToken = '';
      }
    },
    loginAgain() {
      this.$message({
        message: '登录过期，请重新登录！',
        type: 'warning'
      });
      this.showNum = 3; //验证登录
    },
    //判断token是否过期
    jugeToken() {
      const that = this;
      let params = {};
      request.post('/calLogin/getLoginInfo', params, { category: 'WuFan', lhToken: that.lhToken }).then(res => {
        if (res.success) {
          if (!res.data) that.loginAgain();
          else that.showNum = 1; //直接查询
        } else {
          this.$notify({
            title: '错误提示',
            type: 'warning',
            message: res.errMsg
          });
        }
      });
    },
    handleIconClick() {
      if (!this.psType) this.psType = 'password';
      else this.psType = '';
    },
    rebackHome() {
      this.showNum = 1;
      this.ruleForm.name = '';
    },
    closeViewer() {
      this.showViewer = false;
    },
    // 报告预览- 根据订单拉取报告
    exportPreview(item) {
      const that = this;
      let params = {
        documentNo: item.documentNo
      };
      request.post('/queryReportPath', params, { category: 'WuFan', lhToken: that.lhToken }).then(res => {
        if (res.success) {
          if (res.data.length === 0) {
            this.$notify({
              title: '温馨提示',
              type: 'warning',
              message: '抱歉，报告未出请耐心等候;'
            });
          } else {
            // that.showViewer = 2;
            // that.srcList = res.data;
            wx.previewImage({
              current: '', // 当前显示图片的http链接
              urls: res.data // 需要预览的图片http链接列表
            });
          }
        } else {
          if (res.errCode == 'E888') {
            that.loginAgain();
          } else {
            this.$notify({
              title: '错误提示',
              type: 'warning',
              message: res.errMsg
            });
          }
        }
      });
    },

    // closeDiaglogHs() {
    //   this.$confirm('恭喜你,绑定成功！', '成功提示', {
    //     confirmButtonText: '我已确定',
    //     cancelButtonText: '取消',
    //     customClass: 'customClassHs',
    //     confirmButtonClass: 'confirmButtonClassHs',
    //     showClose: false,
    //     showCancelButton: false,
    //     closeOnClickModal: false,
    //     type: 'success',
    //     center: true
    //   }).then(() => {
    //     setTimeout(() => {
    //       wx.closeWindow(); //关闭当前页面
    //     }, 800);
    //   });
    // },

    //submitLoginForm登录提交按钮
    submitLoginForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.goLogin();
        } else {
          return false;
        }
      });
    },
    // 等录
    goLogin() {
      const that = this;
      let params = {
        account: that.ruleLoginForm.account,
        password: that.ruleLoginForm.password
      };
      request.post('/calLogin/index', params, { category: 'WuFan' }).then(res => {
        if (res.success && res.data && res.data.token) {
          that.lhToken = res.data.token;
          localStorage.setItem('lhAccount', JSON.stringify(that.ruleLoginForm));
          localStorage.setItem('lhToken', res.data.token);
          that.showNum = 1;
        } else {
          this.$notify({
            title: '错误提示',
            type: 'warning',
            message: res.errMsg
          });
        }
      });
    },
    // 查询确定-提交按钮
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.searhPatient();
        } else {
          return false;
        }
      });
    },
    // 搜索病人信息
    searhPatient() {
      const that = this;
      let params = {
        patientName: that.ruleForm.name
      };
      request.post('/longhui/queryReportByName', params, { category: 'WuFan', lhToken: that.lhToken }).then(res => {
        if (res.success) {
          if (res.data.length === 0) {
            this.$notify({
              title: '错误提示',
              type: 'warning',
              duration: 2000,
              message: '抱歉，未查取到此人报告数据'
            });
          } else {
            that.showNum = 2;
            that.reportList = res.data;
            that.reportList.forEach(item => {
              item.pslNameArr = item.pslName.split(',');
            });
          }
        } else {
          if (res.errCode == 'E888') {
            that.loginAgain();
          } else {
            this.$notify({
              title: '错误提示',
              type: 'warning',
              message: res.errMsg
            });
          }
        }
      });
    },
    //检查手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style>
.customClassHs {
  width: 60vw !important;
  /* font-size: 18px !important; */
}
.confirmButtonClassHs {
  width: 100px !important;
}

html,
body {
  font-size: 22px;
}
</style>

<style lang="scss" scoped>
    ::v-deep .el-input--small .el-input__inner {
      height: 40px !important;
    }
    .area-content {
      height: 100vh;
      width: 100vw;
      overflow-y: auto;
      box-sizing: border-box;
      position: relative;
      background: url('../../assets/img/report9.jpg');
      background-repeat: no-repeat;
      background-size: cover;

      .bottom-tips {
        width: 100%;
        font-size: 14px;
        color: #8e8b8b;
        position: absolute;
        bottom: 10px;
        text-align: center;
      }

      .reabckBtn {
        color: #fff;
        position: fixed;
        bottom: 0;
        right: 0;
        width: 50px;
        height: 50px;
        border-radius: 50% 0 0 50%;
        background-color: #409eff;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        z-index: 20;
      }
    }

    .mainArea {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      // border: 1px solid red;
      box-sizing: border-box;
      // background-color: #f6f6f6;
      padding: 5px 10px;
      z-index: 10;
      box-sizing: border-box;

      .patient-box {
        width: 100%;
        height: 120px;
        border-radius: 6px;
        // background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        box-sizing: border-box;

        .head-pic {
          width: 85px;
          height: 85px;
          //  border: 1px solid red;
          border-radius: 50%;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .order-box {
        width: 100%;
        height: auto;
        padding: 10px 10px;
        border-radius: 6px;
        // background-color: #fff;
        box-sizing: border-box;
        // border: 1px solid red;
        margin-top: 20px;
        z-index: 1000;

        .comfirm-btn {
          width: 100%;
          // border: 1px solid red;
          display: flex;
          justify-content: center;
          margin-top: 40px;
        }

        .order-title {
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          color: #333333;
          font-weight: bold;
          margin-bottom: 10px;
        }

        .order-info {
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Regular;
          text-align: left;
          color: #333333;
          margin-bottom: 6px;
          white-space: normal;
          word-break: break-all;
        }
      }

      .orderListBox {
        margin-top: 0.5rem;
        margin-bottom: 1.5rem;
        position: relative;
        padding: 0 0.694444rem;
        .showCss {
          width: 200px;
          text-align: center;
          .showTextCss {
            margin-top: 20px;
            color: red;
          }
        }
        .orderListBoxLine {
          width: 0.05rem;
          height: 2.5rem;
          position: absolute;
          top: 0.95rem;
          left: 4.5rem;
          background-color: #d0d0d0;
        }
        .orderListItem {
          // width: 96%;
          min-height: 4.4rem;
          border-radius: 0.5rem;
          background-color: #ffffff;
          display: flex;
          justify-content: space-between;
          margin-bottom: 0.5rem;
          // padding: 0.1rem;
          // box-sizing: border-box;

          .leftBox {
            width: 4.5rem;
            min-width: none;
            min-height: 4.4rem;
            border-right: 1px dashed #d0d0d0;
            .orderListItemLT {
              width: 2.6rem;
              height: 1rem;
              background-color: rgb(255, 174, 0);
              color: #ffffff;
              font-weight: 400;
              -webkit-text-size-adjust: none;
              font-size: 0.4rem;
              line-height: 1rem;
              text-align: center;
              border-radius: 0.5rem 0 0.5rem 0;
            }
            .orderListItemLT1 {
              width: 2.6rem;
              height: 1rem;
              background-color: #94c0ff;
              color: #ffffff;
              font-weight: 400;
              -webkit-text-size-adjust: none;
              font-size: 0.4rem;
              line-height: 1rem;
              text-align: center;
              border-radius: 0.5rem 0 0.5rem 0;
            }
            .orderListItemLT2 {
              width: 2.6rem;
              height: 1rem;
              background-color: #ffc794;
              color: #ffffff;
              font-weight: 400;
              -webkit-text-size-adjust: none;
              font-size: 0.4rem;
              line-height: 1rem;
              text-align: center;
              border-radius: 0.5rem 0 0.5rem 0;
            }

            .leftBoxName {
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              width: 100%;
              height: 1rem;
              line-height: 1rem;
              text-align: center;
              font-size: 0.8rem;
              font-weight: 400;
              color: #343434;
              margin-top: 0.35rem;
            }
            .leftBoxSxe {
              width: 100%;
              height: 1rem;
              line-height: 0.35rem;
              text-align: center;
              font-size: 0.8rem;
              font-size: 0.6rem;
              font-weight: 400;
              color: #666666;
              margin-top: 0.5rem;
            }
          }

          .centerBox {
            flex: 1;
            min-height: 4.4rem;
            padding-left: 0.7rem;
            // border: 1px solid red;
            .centerBoxTime {
              // width: 6.5rem;
              height: 0.7rem;
              font-size: 0.7rem;
              font-weight: 500;
              line-height: 0.5rem;
              color: #202020;
              margin-top: 1rem;
            }
            .centerBoxRegion {
              margin-top: 0.5rem;
              color: #202020;
              font-weight: 400;
              font-size: 0.6rem;
              word-wrap: break-word;
              overflow-wrap: break-word;
              margin-bottom: 0.2rem;
            }
          }
          // .rightBox {
          //   width: 1.5rem;
          //   height: 4.4rem;
          //   background-color: #ff8662;
          //   border-radius: 0 0.5rem 0.5rem 0;
          //   .rightBoxText {
          //     width: 0.65rem;
          //     height: 3rem;
          //     color: #ffffff;
          //     font-weight: 400;
          //     font-size: 0.7rem;
          //     line-height: 0.8rem;
          //     margin-top: 0.7rem;
          //     margin-left: 0.425rem;
          //   }
          // }
        }
      }
    }
</style>
